import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["defaultTransition"],
  _excluded2 = ["delay", "times", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.sort.js";
import { createGeneratorEasing } from '../../easing/utils/create-generator-easing.mjs';
import { resolveElements } from '../../render/dom/utils/resolve-element.mjs';
import { defaultOffset } from '../../utils/offsets/default.mjs';
import { fillOffset } from '../../utils/offsets/fill.mjs';
import { progress } from '../../utils/progress.mjs';
import { secondsToMilliseconds } from '../../utils/time-conversion.mjs';
import { isMotionValue } from '../../value/utils/is-motion-value.mjs';
import { calcNextTime } from './utils/calc-time.mjs';
import { addKeyframes } from './utils/edit.mjs';
import { compareByTime } from './utils/sort.mjs';
var defaultSegmentEasing = "easeInOut";
function createAnimationsFromSequence(sequence) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$defaultTransitio = _ref.defaultTransition,
    defaultTransition = _ref$defaultTransitio === void 0 ? {} : _ref$defaultTransitio,
    sequenceTransition = _objectWithoutProperties(_ref, _excluded);
  var scope = arguments.length > 2 ? arguments[2] : undefined;
  var defaultDuration = defaultTransition.duration || 0.3;
  var animationDefinitions = new Map();
  var sequences = new Map();
  var elementCache = {};
  var timeLabels = new Map();
  var prevTime = 0;
  var currentTime = 0;
  var totalDuration = 0;
  /**
   * Build the timeline by mapping over the sequence array and converting
   * the definitions into keyframes and offsets with absolute time values.
   * These will later get converted into relative offsets in a second pass.
   */
  var _loop = function _loop() {
      var segment = sequence[i];
      /**
       * If this is a timeline label, mark it and skip the rest of this iteration.
       */
      if (typeof segment === "string") {
        timeLabels.set(segment, currentTime);
        return 0; // continue
      } else if (!Array.isArray(segment)) {
        timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
        return 0; // continue
      }
      var _segment = _slicedToArray(segment, 3),
        subject = _segment[0],
        keyframes = _segment[1],
        _segment$ = _segment[2],
        transition = _segment$ === void 0 ? {} : _segment$;
      /**
       * If a relative or absolute time value has been specified we need to resolve
       * it in relation to the currentTime.
       */
      if (transition.at !== undefined) {
        currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
      }
      /**
       * Keep track of the maximum duration in this definition. This will be
       * applied to currentTime once the definition has been parsed.
       */
      var maxDuration = 0;
      var resolveValueSequence = function resolveValueSequence(valueKeyframes, valueTransition, valueSequence) {
        var elementIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var numElements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var valueKeyframesAsList = keyframesAsList(valueKeyframes);
        var _valueTransition$dela = valueTransition.delay,
          delay = _valueTransition$dela === void 0 ? 0 : _valueTransition$dela,
          _valueTransition$time = valueTransition.times,
          times = _valueTransition$time === void 0 ? defaultOffset(valueKeyframesAsList) : _valueTransition$time,
          _valueTransition$type = valueTransition.type,
          type = _valueTransition$type === void 0 ? "keyframes" : _valueTransition$type,
          remainingTransition = _objectWithoutProperties(valueTransition, _excluded2);
        var _valueTransition$ease = valueTransition.ease,
          ease = _valueTransition$ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition$ease,
          duration = valueTransition.duration;
        /**
         * Resolve stagger() if defined.
         */
        var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
        /**
         * If this animation should and can use a spring, generate a spring easing function.
         */
        var numKeyframes = valueKeyframesAsList.length;
        if (numKeyframes <= 2 && type === "spring") {
          /**
           * As we're creating an easing function from a spring,
           * ideally we want to generate it using the real distance
           * between the two keyframes. However this isn't always
           * possible - in these situations we use 0-100.
           */
          var absoluteDelta = 100;
          if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
            var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
            absoluteDelta = Math.abs(delta);
          }
          var springTransition = _objectSpread({}, remainingTransition);
          if (duration !== undefined) {
            springTransition.duration = secondsToMilliseconds(duration);
          }
          var springEasing = createGeneratorEasing(springTransition, absoluteDelta);
          ease = springEasing.ease;
          duration = springEasing.duration;
        }
        duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
        var startTime = currentTime + calculatedDelay;
        var targetTime = startTime + duration;
        /**
         * If there's only one time offset of 0, fill in a second with length 1
         */
        if (times.length === 1 && times[0] === 0) {
          times[1] = 1;
        }
        /**
         * Fill out if offset if fewer offsets than keyframes
         */
        var remainder = times.length - valueKeyframesAsList.length;
        remainder > 0 && fillOffset(times, remainder);
        /**
         * If only one value has been set, ie [1], push a null to the start of
         * the keyframe array. This will let us mark a keyframe at this point
         * that will later be hydrated with the previous value.
         */
        valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
        /**
         * Add keyframes, mapping offsets to absolute time.
         */
        addKeyframes(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
        maxDuration = Math.max(calculatedDelay + duration, maxDuration);
        totalDuration = Math.max(targetTime, totalDuration);
      };
      if (isMotionValue(subject)) {
        var subjectSequence = getSubjectSequence(subject, sequences);
        resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
      } else {
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */
        var elements = resolveElements(subject, scope, elementCache);
        var numElements = elements.length;
        /**
         * For every element in this segment, process the defined values.
         */
        for (var elementIndex = 0; elementIndex < numElements; elementIndex++) {
          /**
           * Cast necessary, but we know these are of this type
           */
          keyframes = keyframes;
          transition = transition;
          var element = elements[elementIndex];
          var _subjectSequence = getSubjectSequence(element, sequences);
          for (var key in keyframes) {
            resolveValueSequence(keyframes[key], getValueTransition(transition, key), getValueSequence(key, _subjectSequence), elementIndex, numElements);
          }
        }
      }
      prevTime = currentTime;
      currentTime += maxDuration;
    },
    _ret;
  for (var i = 0; i < sequence.length; i++) {
    _ret = _loop();
    if (_ret === 0) continue;
  }
  /**
   * For every element and value combination create a new animation.
   */
  sequences.forEach(function (valueSequences, element) {
    for (var key in valueSequences) {
      var valueSequence = valueSequences[key];
      /**
       * Arrange all the keyframes in ascending time order.
       */
      valueSequence.sort(compareByTime);
      var keyframes = [];
      var valueOffset = [];
      var valueEasing = [];
      /**
       * For each keyframe, translate absolute times into
       * relative offsets based on the total duration of the timeline.
       */
      for (var _i = 0; _i < valueSequence.length; _i++) {
        var _valueSequence$_i = valueSequence[_i],
          at = _valueSequence$_i.at,
          value = _valueSequence$_i.value,
          easing = _valueSequence$_i.easing;
        keyframes.push(value);
        valueOffset.push(progress(0, totalDuration, at));
        valueEasing.push(easing || "easeOut");
      }
      /**
       * If the first keyframe doesn't land on offset: 0
       * provide one by duplicating the initial keyframe. This ensures
       * it snaps to the first keyframe when the animation starts.
       */
      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        keyframes.unshift(keyframes[0]);
        valueEasing.unshift(defaultSegmentEasing);
      }
      /**
       * If the last keyframe doesn't land on offset: 1
       * provide one with a null wildcard value. This will ensure it
       * stays static until the end of the animation.
       */
      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        keyframes.push(null);
      }
      if (!animationDefinitions.has(element)) {
        animationDefinitions.set(element, {
          keyframes: {},
          transition: {}
        });
      }
      var definition = animationDefinitions.get(element);
      definition.keyframes[key] = keyframes;
      definition.transition[key] = _objectSpread(_objectSpread({}, defaultTransition), {}, {
        duration: totalDuration,
        ease: valueEasing,
        times: valueOffset
      }, sequenceTransition);
    }
  });
  return animationDefinitions;
}
function getSubjectSequence(subject, sequences) {
  !sequences.has(subject) && sequences.set(subject, {});
  return sequences.get(subject);
}
function getValueSequence(name, sequences) {
  if (!sequences[name]) sequences[name] = [];
  return sequences[name];
}
function keyframesAsList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
}
function getValueTransition(transition, key) {
  return transition[key] ? _objectSpread(_objectSpread({}, transition), transition[key]) : _objectSpread({}, transition);
}
var isNumber = function isNumber(keyframe) {
  return typeof keyframe === "number";
};
var isNumberKeyframesArray = function isNumberKeyframesArray(keyframes) {
  return keyframes.every(isNumber);
};
export { createAnimationsFromSequence, getValueTransition };